export default class Profile {

  constructor(userId, name, email) {
    this.userId = userId;
    this.name = name;
    this.email = email;
    this.role = Profile.ROLE_EMPLOYEE;
    this.delegation = false;
    this.employeeopplus = true;
  }

  compareTo(profile) {
    return this.profile.userId === profile.userId;
  }

  static ROLE_EMPLOYEE() {
    return 'normal';
  }

  static ROLE_MANAGER() {
    return 'manager';
  }

  static DELEGATION_USER() {
    return 'R';
  }

  static DELEGATION_MANAGER() {
    return 'A';
  }
}



// WEBPACK FOOTER //
// ./client/app/common/domain/models/profile.js